<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Edit Purpose
            </h2>
        </template>

        <purpose-form :purpose="purpose" :action="route('purposes.update', purpose.id)" button="Update"></purpose-form>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout';
    import PurposeForm from './Form';

    export default {
        props: ['purpose'],

        components: {
            AppLayout,
            PurposeForm,
        },
    }
</script>
